import React, { useState, useEffect, useRef } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import { gsap } from "gsap";
import styles from "./TabsComponent.module.css";

const tabData = [
  {
    label: "Game Assets",
    video:
      "https://leonardo-cdn.b-cdn.net/wp-content/uploads/2024/05/Image_gen_email__.webm",
  },
  {
    label: "Concept Art",
    video:
      "https://leonardo-cdn.b-cdn.net/wp-content/uploads/2024/05/Image_gen_email__.webm",
  },
  {
    label: "Graphic Design",
    video:
      "https://leonardo-cdn.b-cdn.net/wp-content/uploads/2024/05/Image_gen_email__.webm",
  },
  {
    label: "Character Design",
    video:
      "https://leonardo-cdn.b-cdn.net/wp-content/uploads/2024/05/Image_gen_email__.webm",
  },
  {
    label: "Fashion",
    video:
      "https://leonardo-cdn.b-cdn.net/wp-content/uploads/2024/05/Image_gen_email__.webm",
  },
  {
    label: "Advertising",
    video:
      "https://leonardo-cdn.b-cdn.net/wp-content/uploads/2024/05/Image_gen_email__.webm",
  },
  {
    label: "Product Photography",
    video:
      "https://leonardo-cdn.b-cdn.net/wp-content/uploads/2024/05/Image_gen_email__.webm",
  },
];

const TabsComponent = () => {
  const [activeTab, setActiveTab] = useState(0);
  const imageRef = useRef(null);
  const underlineRef = useRef(null);
  const tabsRef = useRef([]);
  const tabsContainerRef = useRef(null);

  useEffect(() => {
    const updateUnderlinePosition = () => {
      const activeTabElement = tabsRef.current[activeTab];
      if (!activeTabElement) return;

      const tabRect = activeTabElement.getBoundingClientRect();
      const containerRect = tabsContainerRef.current.getBoundingClientRect();

      gsap.to(underlineRef.current, {
        duration: 0.5,
        left: tabRect.left - containerRect.left,
        width: tabRect.width,
        ease: "power3.out",
      });
    };

    updateUnderlinePosition();
    window.addEventListener("resize", updateUnderlinePosition);
    return () => window.removeEventListener("resize", updateUnderlinePosition);
  }, [activeTab]);

  useEffect(() => {
    gsap.fromTo(
      imageRef.current,
      { opacity: 0, y: 20, scale: 0.98 },
      { opacity: 1, y: 0, scale: 1, duration: 0.8, ease: "power3.out" }
    );
  }, [activeTab]);

  const handleTabChange = (event, newValue) => {
    gsap.to(imageRef.current, {
      opacity: 0,
      y: -20,
      duration: 0.3,
      ease: "power3.in",
      onComplete: () => {
        setActiveTab(newValue);
      },
    });
  };

  return (
    <div className={styles.container}>
      <Typography variant="h2" className={styles.title}>
        Use <span className={styles.leonardoText}>Remini</span> today for
      </Typography>

      <div className={styles.tabsWrapper} ref={tabsContainerRef}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          className={styles.tabs}
          TabIndicatorProps={{ style: { display: "none" } }}
        >
          {tabData.map((tab, index) => (
            <Tab
              key={index}
              ref={(el) => (tabsRef.current[index] = el)}
              label={
                <span
                  className={`${styles.tabText} ${
                    activeTab === index ? styles.activeGradient : ""
                  }`}
                >
                  {tab.label}
                </span>
              }
              className={styles.tab}
            />
          ))}
        </Tabs>
        <div ref={underlineRef} className={styles.animatedUnderline} />
      </div>

      <Box className={styles.imageContainer} ref={imageRef}>
        <video
          autoPlay
          muted
          loop
          playsInline
          src={tabData[activeTab].video}
          alt={tabData[activeTab].label}
          className={styles.image}
          loading="lazy"
        />
      </Box>
    </div>
  );
};

export default TabsComponent;
